<template>
  <div class="headerMenu">
    <div class="header">
        <v-list width="200" color="rgb(67,80,88)" class="d-flex flex-column justify-space-between fill-height">
          <v-list-item-group v-show="!bookiesLoading">
            <v-list-item dense class="white--text"
             dark
              active-class="white--text bookieSelected"
              @click="setSelectedBookie(null), selectedAll()">
              <h3 class="mr-1">All</h3>
              <strong style="margin-left: auto">
                ${{numeral(allBetsTotalMeeting()).format('0,0.00')}}</strong>
            </v-list-item>
<!--            <v-list-item dense v-for="i in 10" :key="i" class="white&#45;&#45;text"-->
<!--             active-class="white&#45;&#45;text bookieSelected"-->
<!--             dark>-->
<!--              <img src="https://betmakers.com/img/circle_logos/RW.png" width="28px" style="padding-right: 5px">-->
<!--              <strong>${{numeral(100000).format('0,0.00')}}</strong>-->
<!--            </v-list-item>-->
            <v-list-item dense v-for="item in bookiescolumn" :key="item.bookie" class="white--text mb-auto"
             active-class="white--text bookieSelected"
             dark
              @click="setSelectedBookie(item.bookie), selectedBookmaker()">
              <img :src="`https://betmakers.com/img/circle_logos/${item.bookie}.png`" height="32px" style="padding-right: 5px">
              <strong style="margin-left: auto">
                ${{numeral(item.total).format('0,0.00')}}</strong>
            </v-list-item>
          </v-list-item-group>
          <div v-show="bookiesLoading">
            <v-list v-for="idx in 10" height="48px" :key="idx" class="meetings-list">
              <v-skeleton-loader
                dark
                type="list-item-avatar"
              ></v-skeleton-loader>
            </v-list>
          </div>
        </v-list>
        <v-list-item
          dense
          class="white--text mt-n5"
          dark
          active-class="white--text bookieSelected">
          <h4 class="mr-1">Date Total</h4>
          <strong style="margin-left: auto; font-size: 13px">
            ${{numeral(allBetsAllBookies()).format('0,0.00')}}</strong>
        </v-list-item>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import numeral from 'numeral'
import { loaders } from '@/store'

export default {
  name: 'BookieColumn',
  props: {
    items: {
      type: Array,
      default: () => []
    },
    bookiesrace: {
      type: Array,
      default: () => []
    },
    viewType: {
      type: String
    },
    updateDataTableHeight: {
      type: Function
    }
  },
  data () {
    return {
      numeral,
      bookie_button: 0
    }
  },
  computed: {
    ...mapState(['selectedRace', 'selectedMeeting', 'loading', 'allBookies', 'bookiescolumn']),
    bookiesLoading () {
      return this.loading[loaders.BOOKIE_BETS]
    }
  },
  methods: {
    ...mapActions(['clearSelections', 'clearBetsByType', 'setSelectedBookie', 'fetchRunners', 'fetchRaces', 'fetchRacesDated', 'fetchBets', 'fetchBetsByType', 'fetchBookieBets', 'fetchBookieBetsDated', 'fetchBookieRace', 'fetchBookieMeeting']),
    allBetsTotal () {
      return this.items.reduce((acc, curr) => acc + curr.total, 0)
    },
    allBetsTotalMeeting () {
      return this.bookiescolumn.reduce((acc, curr) => acc + curr.total, 0)
    },
    allBetsAllBookies () {
      return this.allBookies.reduce((acc, curr) => acc + curr.total, 0)
    },
    selectedAll () {
      // this.bookie_button = [0]
      this.clearBetsByType()
      this.fetchBookieRace()
      this.fetchBetsByType()
      this.updateDataTableHeight()
      if (this.selectedMeeting !== null) {
        this.fetchRaces()
      }
      if (this.selectedRace !== null) {
        this.fetchRunners()
      }
      if (this.viewType === 'overView') {
        this.fetchBetsByType()
      }
      // this.fetchBookieBets()
      // this.fetchBookieBetsDated()
    },
    selectedBookmaker () {
      this.clearBetsByType()
      this.fetchBetsByType()
      this.fetchBookieMeeting()
      this.updateDataTableHeight()
      if (this.selectedMeeting !== null) {
        this.fetchRacesDated()
      }
      if (this.selectedRace !== null) {
        this.fetchRunners()
      }
      if (this.viewType === 'overView') {
        this.fetchBetsByType()
      }
      // this.fetchBookieBets()
      // this.fetchBookieBetsDated()
    }
  }
}
</script>

<style scoped>
.meetings-list {
  padding: 0px;
}
.v-list{
  height:95vh;/* or any height you want */
  overflow-y:auto
}
.v-list-item {
  padding-right: 8px;
  padding-left: 8px;
}
.bookieSelected {
  background: rgb(233, 10, 124) !important;
  color: white;
}
.headerMenu {
  display: flex;
}
.bookieHeaderTabs {
  max-height:40px;
}
</style>
